import React, { useState, useEffect } from 'react';
import '../../css/Shared/UploadMultipleFile.css';
import upload from '../../Assets/ProfileManagement/Assets-Desktop/upload.svg';
import closeIcon from '../../Assets/ProfileManagement/Assets-Desktop/close.svg';
import uploadDisable from '../../Assets/ProfileManagement/Assets-Desktop/uploadDisable.svg';
import { ApiCall } from '../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../Services/config/apiGateway';
import { DOCUMENT_ENDPOINT } from '../../Services/config/apiEndPoints';
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
toast.configure()
const UploadMultipleFile = (props) => {
    const [uploadedFiles, setuploadedFiles] = useState([]);
    const [isUploadDisabled, setIsUploadDisabled] = useState(false);
    let filNameArray = [];
    let remainingData = [];
    let CheckVerifyFileType;
    function anchorClick(e) {
        e.preventDefault();
        document.querySelector('#' + props.idupload).click();
    }
    useEffect(() => {
        window.$(function () {
            var fileupload = document.getElementById(props.idupload);
            for (let index = 0; index <= 2; index++) {
                fileupload.onchange = function (e) {
                    if (props.fileType === "jpeg, jpg, png, pdf") {
                        CheckVerifyFileType = fileupload.value.match(/pdf$/) || fileupload.value.match(/PDF$/) || fileupload.value.match(/jpeg$/) || fileupload.value.match(/jpg$/) || fileupload.value.match(/png$/)
                    }
                    if (props.fileType === "png, jpg, pdf") {
                        CheckVerifyFileType = fileupload.value.match(/pdf$/) || fileupload.value.match(/jpg$/) || fileupload.value.match(/png$/)
                    }
                    let files = e.target.files[0];
                    console.log("hdgdfgjfgdgdgjdj", files)
                  
                    if (CheckVerifyFileType) {
                        if (fileupload.files.length > 0) {
                            for (let i = 0; i <= fileupload.files.length - 1; i++) {
                                const fsize = fileupload.files.item(i).size;
                                const file = Math.round((fsize / 1024));
                                if (file > 2048) {
                                    toast("File too big, please select a file less than 2 MB." ,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}});
                                }
                                else {
                                  
                                    const reader = new window.FileReader();
                                    reader.readAsDataURL(files);
                                    reader.onload = (f) => {
                                        const newName = files.name.replace(/[&\/\\#,+ ()$~%'":*?<>{​​​}​​​]/g, '');
                                        const formData1 = new window.FormData();
                                        formData1.append('file', files, newName);
                                        console.log("before api call", formData1);
                                        ApiCall(
                                            'POST',
                                            utilityBaseURL +
                                            DOCUMENT_ENDPOINT,
                                            formData1,
                                            {
                                                Accept: 'application/json',
                                            },
                                            true,
                                            true
                                        ).then((response) => response)
                                            .then((data) => {
                                                if (data.flag != -1) {
                                                    if (data.flag == 500) {
                                                        console.log("I am 500!");
                                                    }
                                                    else {
                                                    console.log('I am 200!');
                                                    console.log("file path api", data);
                                                    var uploadedfileName = fileupload.value.split('\\')[fileupload.value.split('\\').length - 1];
                                                   // setFileName(uploadedfileName);
                                                    filNameArray.push(uploadedfileName);
                                                    setuploadedFiles(filNameArray);
                                                    if (filNameArray.length >= 3) {
                                                        setIsUploadDisabled(true);
                                                    }
                                                    toast("File uploaded sucessfully." ,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}});
                                                    props.setUploadConfirm(true);
                                                    props.setFileLink(data.documentPath);
                                                    props.ShipmentDetailesCallback(filNameArray);
                                                }
                                             } else {
                                                    props.setLoader(false);
                                                }
                                            });
                                    }
                                }
                            }
                        }
                    }
                    else {
                        (props.fileType === "jpeg, jpg, png, pdf") && 
                        toast("File should be jpeg, jpg, png and pdf." ,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}});
                        (props.fileType === "png, jpg, pdf") && 
                        toast("File should be png, jpg and pdf." ,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}});
                    }
                };
            }
        });
    }, []);
    return (
        <div class="predocuupload" id={props.uploaddivid}>
            {uploadedFiles.map((val, index) => {
                return (
                    <>
                        <span style={{ display: "flex" }} id={props.vatFile} className="predocfilename">
                            <div className="predocuploadedFilenameimg">
                                <div className="predocuploadedfilename">{val}</div>
                                <img alt="" onClick={() => {
                                    setIsUploadDisabled(false);
                                    console.log('close requested')
                                    remainingData =uploadedFiles;
                                    console.log('ap---',uploadedFiles)
                                    remainingData.splice(index, 1);
                                    setuploadedFiles(remainingData);
                                    filNameArray = remainingData;
                                }} src={closeIcon} width="45" height="45" class="pb-1" />
                            </div>
                        </span>
                        <hr className="predocspanhr" style={{ display: "flex" }} />
                    </>)
            })}
            <div className="predocshowupload" style={{ pointerEvents: isUploadDisabled && "none" }}>
                <div class="predocuuploadsize">
                    <img src={isUploadDisabled ? uploadDisable : upload}
                        style={{ cursor: "pointer" }}
                        id={props.uploadicon}
                        class="mt-1"
                        alt="" width="15" height="15" loading="lazy" />
                    <input id={props.idupload} name={props.name} type="file" required disabled={isUploadDisabled} />
                    <Link to="#" style={{ color: isUploadDisabled ? "#C4C4C4" : "#d42e12", cursor: "pointer" }}
                        id={props.upload_link}
                        class="UploadRedCss" onClick={anchorClick}
                    >Upload File</Link>
                </div>
                <div class="predocufilesize">
                    <div class="predocudisflex1">
                        {(props.fileType === "png, jpg, pdf") ?
                            <small class="predocfile" id={props.vatUploadType}> File Types : </small>
                            :
                            <small class="predocfile" id={props.vatUploadType}> Type : </small>
                        }
                        <small class="predocfile1" id={props.vatUploadTypeName}> {props.fileType}</small>
                    </div>
                    <div class="predocudisflex2">
                        <small class="predocfile" id={props.vatUploadSize}> File Size : </small>
                        {(props.fileType === "png, jpg, pdf") ?
                            <small class="predocfile1" id={props.vatUploadSizeName}> 2 MB each</small>
                            :
                            <small class="predocfile1" id={props.vatUploadSizeName}> 2 MB (Max.)</small>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
export default UploadMultipleFile;
